module.exports = __webpack_public_path__ + "static/media/art3.cbb017a9.jpg";